/*
 * @Author: Teemo Ding
 * @Date: 2022-03-23 14:40:42
 * @LastEditTime: 2022-03-25 14:09:05
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/EditSenderInfo/index.tsx
 */
import React, { Fragment } from 'react';
import { Form } from 'antd';
import { get } from 'lodash';
import { useRequest } from 'ahooks';
import { getCountries } from 'src/request/common';
import { getState } from 'src/request/settings/storeDetails';
import { MobileNumberAreaInfo } from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { ModalFooter, Input, Select } from '@/src/components/Antd';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const EditSenderInfo = ({ onCancel, onConfirm, senderInfo }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  // const { data: areaCodes = [] } = useRequest(() => getAreaCodeAll());
  const { data: countriesAll = [] } = useRequest(() => getCountries(), {
    onSuccess: () => {
      const {
        mobile: mobileNumber,
        areaCode,
        areaCodeInfo,
        address,
        countryUuid,
        name,
        postalCode,
        provinceUuid,
      } = senderInfo || {};
      const senderPhone = {
        areaCode,
        mobileNumber,
        areaCodeInfo,
      };
      if (countryUuid) {
        handleGetStates(countryUuid);
      }
      form.setFieldsValue({
        senderPhone,
        address,
        countryUuid,
        name,
        postalCode,
        provinceUuid,
      });
    },
  });
  const { data: states = [], run: _getState } = useRequest(
    (countryCode) => getState(countryCode),
    { manual: true },
  );
  // const areaCodesOptions = areaCodes.map((item) => ({
  //   label: `+ ${item.areaCode}`,
  //   value: item.areaCode,
  //   uuid: item.uuid,
  // }));
  const countryOption = (countriesAll || []).map((item) => ({
    label: item.name,
    value: get(item, 'uuid', ''),
  }));
  const stateOption = (states || []).map((item) => ({
    label: item.name,
    value: get(item, 'uuid', ''),
  }));

  const onFinish = (values) => {
    const { countryUuid, provinceUuid, senderPhone } = values || {};
    const { areaCode, mobileNumber: mobile, areaCodeInfo } = senderPhone || {};
    const countyIndex = countriesAll.filter((o) => o.uuid === countryUuid);
    const provinceIndex = states.filter((o) => o.uuid === provinceUuid);
    const data = {
      ...values,
      countryName: (countyIndex[0] || {}).name,
      provinceName: (provinceIndex[0] || {}).name,
      areaCode,
      mobile,
      areaCodeInfo,
    };
    if (onConfirm) {
      onConfirm(data);
    }
  };

  const handleGetStates = (countryUuid) => {
    const countyIndex = countriesAll.filter((o) => o.uuid === countryUuid);
    _getState((countyIndex[0] || {}).code);
  };

  const onValuesChange = (changedValues) => {
    if (Object.keys(changedValues).includes('countryUuid')) {
      form.setFieldsValue({ provinceUuid: '' });
      handleGetStates(changedValues['countryUuid']);
    }
  };

  return (
    <Fragment>
      <Form
        className={css.senderPhone}
        form={form}
        onFinish={onFinish}
        onValuesChange={onValuesChange}>
        <Form.Item
          name='name'
          label={`${getI18n('allOrders.createneworder.senderName')}*`}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('allOrders.createneworder.senderName'),
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Input size='large' />
        </Form.Item>
        <Form.Item
          name='senderPhone'
          label={`${getI18n('allOrders.createneworder.senderPhone')}*`}
          labelCol={{ span: 24 }}>
          <MobileNumberAreaInfo />
        </Form.Item>
        <Form.Item
          name='address'
          label={`${getI18n('allOrders.createneworder.addressLine')}*`}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('allOrders.createneworder.addressLine'),
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Input size='large' />
        </Form.Item>
        <Form.Item
          name='countryUuid'
          label={`${getI18n('general.countryRegion')}*`}
          rules={[
            {
              required: true,
              message: getI18n(
                'allOrders.createneworder.component_customer_BillingAddress_countrymsg',
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Select size='large' options={countryOption} />
        </Form.Item>
        <Form.Item
          name='provinceUuid'
          label={`${getI18n(
            'allOrders.createneworder.stateProvinceDistrict',
          )}*`}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('allOrders.createneworder.stateProvinceDistrict'),
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <Select size='large' options={stateOption} />
        </Form.Item>
        <Form.Item
          name='postalCode'
          label={getI18n('allOrders.createneworder.postcode')}
          labelCol={{ span: 24 }}>
          <Input size='large' />
        </Form.Item>
      </Form>

      <ModalFooter
        onOk={() => form.submit()}
        onCancel={() => onCancel()}
        okText={getI18n('general.confirm')}
      />
    </Fragment>
  );
};

export default EditSenderInfo;
